import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/Httpconfig";
import Constant from "../constants";
import DoctorHeader from "./doctor/DoctorHeader";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { database } from "./helpers/firebase";
import "./chatAppcss/chatapp.css";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");
var timeZone = "Asia/Kolkata";
var localTime = moment().tz(timeZone);
export default class ViewClinics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      messages: [],
      detialsdata: "",
      username: "",
      senderUsername: "",
      loginUsername: "",
      profile_image: "",
      sender_image: "",
      OpenrightImg: "",
      OpenleftImg: "",
      loading: true,
    };
    this.onAddMessage = this.onAddMessage.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    // const userdata =  localStorage.getItem('DocuserObj');
    const userdata = ls.get("DocuserObj");
    var chatuser_id = localStorage.getItem("PatientSenderUID");

    //  const userobj =  JSON.parse(userdata);
    if (userdata.user_type == "doctor") {
      const username = userdata.doctor_id;
      this.setState({ username: username ? username : "Unknown" });
      // ---------------------- To local database get doctor profile image ---------------------------//

      Httpconfig.httptokenget(
        Constant.siteurl + "api/Doctor/DoctorProfiler/" + username
      )
        .then((response) => {
          if (response.status == "200" && response.data.error === false) {
            let doctorProfileImage = "";
            let doctorGender = response.data.data[0].gender.toLowerCase();
            if (response.data.data[0].profile_pic != null) {
              doctorProfileImage = response.data.data[0].profile_pic;
            } else {
              if (doctorGender != null) {
                if (doctorGender == "female") {
                  doctorProfileImage =
                    "../images/patient/img/Profile/Female_patient.svg";
                } else {
                  doctorProfileImage =
                    "../images/patient/img/Profile/Male_patient.svg";
                }
              } else {
                doctorProfileImage =
                  "../images/patient/img/Profile/Male_patient.svg";
              }
            }

            this.setState({
              doctorProfileImage: doctorProfileImage,
              doctorGender: response.data.data[0].gender.toLowerCase(),
              doctorName: response.data.data[0].doctor_name,
            });
          }
        })
        .catch((error) => {
          toast.error(error);
        });
      // ---------------------- To local database get Patient profile image ---------------------------//

      let patientDob = "";
      Httpconfig.httptokenget(
        Constant.siteurl + "api/Patients/" + chatuser_id,
        {}
      ).then((response) => {
        let patientDob = "";

        if (response.data.status == 200 && response.data.error == false) {
          let patientProfileImage = "";
          let PatientGender = response.data.data[0].gender;
          let PatientName = response.data.data[0].name;
          if (response.data.data[0].profile_pic != null) {
            patientProfileImage =
              Constant.imgurl + response.data.data[0].profile_pic;
          } else {
            if (PatientGender != null) {
              if (PatientGender.toLowerCase() == "female") {
                patientProfileImage =
                  "../images/patient/img/Profile/Female_patient.svg";
              } else {
                patientProfileImage =
                  "../images/patient/img/Profile/Male_patient.svg";
              }
            } else {
              patientProfileImage =
                "../images/patient/img/Profile/Male_patient.svg";
            }
          }

          this.setState({
            patientProfileImage: patientProfileImage,
            PatientGender: PatientGender,
            PatientName: PatientName,
          });
        }
      });
      // ---------------------------------------------------------------------------------------------//
    }

    this.fetchpagesdata();
  };
  // Fetch all message data
  fetchpagesdata() {
    // const userdata = localStorage.getItem('DocuserObj');
    const userdata = ls.get("DocuserObj");
    //const userobj =  JSON.parse(userdata);
    if (userdata.user_type == "doctor") {
      var userId = userdata.doctor_id;
    } else {
      var userId = userdata.patient_id;
    }
    var chatuser_id = localStorage.getItem("PatientSenderUID");
    if (chatuser_id && userId) {
      database
        .ref("Chat")
        .child(userId)
        .child(chatuser_id)
        .on("value", (snap) => {
          var res = snap.val();
          this.ChatUserallMessages = [];
          for (var i in res) {
            this.ChatUserallMessages.push(res[i]);
          }

          this.state.detialsdata = this.ChatUserallMessages.map(
            (item, index) => {
              if (item.uid == userdata.doctor_id) {
                return (
                  <React.Fragment>
                    <div class="righttext">
                      <div class="sent_msg">
                        <div class="right_msg">
                          {//------------- Image ------------------//
                          item.type === "image" ? (
                            <div>
                              <img
                                data-toggle="modal"
                                data-target="#myModal"
                                src={item.body}
                                id="myModal"
                                class="displaydoc"
                                onClick={() =>
                                  this.OpenrightRightpopImg(item.body)
                                }
                              />
                              {/* {this.state.doctorProfileImage ? <img src={Constant.imgurl + this.state.doctorProfileImage} alt="Avatar" class = "pro_img"></img> : "" } */}
                              <br />
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </div>
                          ) : //------------- PDF ------------------//
                          item.type == "pdf" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              <img src="../img/file-pdf-Icon.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- DOC ------------------//
                          item.type == "doc" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              <img src="../img/prescriptions.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Xlsx ------------------//
                          item.type == "xlsx" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              <img src="../img/microsoft-excel-icon.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Mp3 ------------------//
                          item.type == "mp3" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              <img src="../img/audio-playlist.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Mp4 ------------------//
                          item.type == "mp4" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              <img src="../img/audio-playlist.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                              {/* <iframe src={item.body} class = "displaydoc"> </iframe>  */}
                            </a>
                          ) : (
                            <p>
                              {item.body}
                              <br />
                              {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </p>
                          )}
                          {this.state.doctorProfileImage ? (
                            <img
                              src={
                                Constant.imgurl + this.state.doctorProfileImage
                              }
                              alt="Avatar"
                              class="pro_img"
                            ></img>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              } else {
                return (
                  <React.Fragment>
                    <div class="lefttext">
                      <div class="received_withd_msg">
                        <div class="left_msg">
                          {//------------- Image ------------------//
                          item.type == "image" ? (
                            <div className="left_msg">
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                                
                              ) : (
                                ""
                              )}
                              <span>
                              <img
                                data-toggle="modal"
                                data-target="#myModal2"
                                src={item.body}
                                class="displaydoc"
                                onClick={() =>
                                  this.OpenrightLeftpopImg(item.body)
                                }
                              />
                               <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                              </span>
                            </div>
                          ) : //------------- Pdf ------------------//
                          item.type == "pdf" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                              ) : (
                                ""
                              )}
                              <img src="../img/file-pdf-Icon.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- DOC ------------------//
                          item.type == "doc" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                              ) : (
                                ""
                              )}
                              <img src="../img/prescriptions.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Xlsx ------------------//
                          item.type == "xlsx" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                              ) : (
                                ""
                              )}
                              <img src="../img/microsoft-excel-icon.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Mp3 ------------------//
                          item.type == "mp3" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                              ) : (
                                ""
                              )}
                              <img src="../img/audio-playlist.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : //------------- Mp4 ------------------//
                          item.type == "mp4" ? (
                            <a
                              onClick={() => this.openInNewTab(item.body)}
                              class="pdfimage"
                            >
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                ></img>
                              ) : (
                                ""
                              )}
                              <img src="../img/audio-playlist.svg"></img>
                              <span>{item.filename ? item.filename : ""}</span>
                              <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                            </a>
                          ) : (
                            //------------- Text ------------------//
                            <div className="left_msg">
                              {this.state.patientProfileImage ? (
                                <img
                                  alt="Avatar"
                                  class="pro_img"
                                  src={this.state.patientProfileImage}
                                >                                  
                                </img>
                                
                              ) : (
                                ""
                              )}
                              <p>
                                {item.body}
                                <br />
                                {moment(item.time, ["HH:mm"]).format("hh:mm a")}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>{" "}
                    </div>
                  </React.Fragment>
                );
              }
            }
          );
          let messagesState = Object.assign({}, this.state);
          this.setState(messagesState);
        });
    } else {
      this.state.detialsdata = (
        <React.Fragment>
          <div>
            <h2>"No Data"</h2>{" "}
          </div>
        </React.Fragment>
      );
      let messagesState = Object.assign({}, this.state);
      this.setState(messagesState);
    }
  }
  // When the click right image its ipen the pop on based on url
  OpenrightRightpopImg = (Url) => {
    this.setState({ OpenrightImg: Url });
    this.state.OpenrightImg = Url;
  };
  // When the click right image its ipen the pop on based on url
  OpenrightLeftpopImg = (Url) => {
    this.setState({ OpenrightImg: Url });
    this.state.OpenleftImg = Url;
  };
  openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  // redirect to appointments Page
  chatEndConsultation=()=>{
   
    const ChatuserObj = JSON.parse(localStorage.getItem("ChatuserObj"));
    var isConfirm = window.confirm(
      "Are you sure to you want to end consultation?"
    );
    if(isConfirm)
    {
    let appointmentId = ChatuserObj.appointment_confirm_id; 
    Httpconfig.httptokenput(
      Constant.siteurl + "api/PatientAppointment/updateDoctorConsentRequest/"+appointmentId,
      {status:3}
    ).then((response) => {
      window.location.href=Constant.imgurl+"/doctor/Doctordashboard";
    })
    }
  }
  // create or update
  checkSubmit(event) {
    event.preventDefault();
    // if(this.input.value)
    // {
    this.onAddMessage();
    // }
  }
  onAddMessage(event) {
    // event.preventDefault();
    const userobj = ls.get("DocuserObj");
    //const userdata = localStorage.getItem('DocuserObj');
    //const userobj =  JSON.parse(userdata); //ls.get("ChatuserObj");
    if (userobj.user_type == "doctor") {
      var userId = userobj.doctor_id;
    } else {
      var userId = userobj.patient_id;
    }

    var chatuser_id = localStorage.getItem("PatientSenderUID");
    if (this.input.value) {
      this.sendMessage(
        this.input.value,
        userId,
        chatuser_id,
        this.state.loginUsername,
        this.state.senderUsername
      );
    }
    this.input.value = "";
  }

  sendMessage(messageDetails, uid, chatuser_id, loginUsername, senderUsername) {
    var currentTime = moment().format("HH:mm");
    var presentDate = moment().format("YYYY-MM-DD");
    var promise = new Promise((resolve, reject) => {
      database
        .ref("Chat")
        .child(uid)
        .child(chatuser_id)
        .push({
          body: messageDetails,
          date: presentDate,
          time: currentTime,
          name: loginUsername,
          text: true,
          uid: uid.toString(),
        })
        .then((snap) => {
          var key = snap.key;
          database
            .ref("Chat")
            .child(chatuser_id)
            .child(uid)
            .child(key)
            .set({
              body: messageDetails,
              date: presentDate,
              time: currentTime,
              name: senderUsername,
              text: true,
              uid: uid.toString(),
              // time: database.ServerValue.TIMESTAMP,
              key: key,
            })
            .then(() => {
              database
                .ref("Chat")
                .child(uid)
                .child(chatuser_id)
                .child(key)
                .update({
                  key: key,
                })
                .then(() => {
                  //start conversations
                  database
                    .ref("Conversations")
                    .child(uid)
                    .orderByChild("uid")
                    .equalTo(chatuser_id)
                    .once("value", (snapshot) => {
                      var res = snapshot.val();
                      if (res != null) {
                        let store = Object.keys(res);
                        database
                          .ref("Conversations")
                          .child(uid)
                          .child(store[0])
                          .remove()
                          .then(() => {
                            database
                              .ref("Conversations")
                              .child(uid)
                              .push({
                                uid: chatuser_id.toString(),
                                text: true,
                                body: messageDetails,
                                date: presentDate,
                                time: currentTime,
                                name: senderUsername,
                              })
                              .then(() => {
                                database
                                  .ref("Conversations")
                                  .child(chatuser_id)
                                  .orderByChild("uid")
                                  .equalTo(uid)
                                  .once("value", (snapshot) => {
                                    var res = snapshot.val();
                                    if (res != null) {
                                      let store = Object.keys(res);
                                      database
                                        .ref("Conversations")
                                        .child(chatuser_id)
                                        .child(store[0])
                                        .remove()
                                        .then(() => {
                                          database
                                            .ref("Conversations")
                                            .child(chatuser_id)
                                            .push({
                                              uid: uid.toString(),
                                              body: messageDetails,
                                              date: presentDate,
                                              time: currentTime,
                                              name: loginUsername,
                                              text: true,
                                            })
                                            .then(() => {
                                              resolve(true);
                                            });
                                        })
                                        .catch((err) => {});
                                    } else {
                                      database
                                        .ref("Conversations")
                                        .child(chatuser_id)
                                        .push({
                                          uid: uid.toString(),
                                          body: messageDetails,
                                          date: presentDate,
                                          time: currentTime,
                                          name: loginUsername,
                                          text: true,
                                        })
                                        .then(() => {
                                          resolve(true);
                                        });
                                    }
                                  })
                                  .catch((err) => {
                                    reject(err);
                                  });
                              });
                          })
                          .catch((err) => {
                            reject(err);
                          });
                      } else {
                        database
                          .ref("Conversations")
                          .child(uid)
                          .push({
                            uid: chatuser_id.toString(),
                            body: messageDetails,
                            date: presentDate,
                            time: currentTime,
                            name: senderUsername,
                            text: true,
                          })
                          .then(() => {
                            database
                              .ref("Conversations")
                              .child(chatuser_id)
                              .orderByChild("uid")
                              .equalTo(chatuser_id)
                              .once("value", (snapshot) => {
                                var res = snapshot.val();

                                if (res != null) {
                                  let store = Object.keys(res);
                                  database
                                    .ref("Conversations")
                                    .child(chatuser_id)
                                    .child(store[0])
                                    .remove()
                                    .then(() => {
                                      database
                                        .ref("Conversations")
                                        .child(chatuser_id)
                                        .push({
                                          uid: uid.toString(),
                                          body: messageDetails,
                                          date: presentDate,
                                          time: currentTime,
                                          name: loginUsername,
                                          text: true,
                                        })
                                        .then(() => {
                                          resolve(true);
                                        });
                                    })
                                    .catch((err) => {
                                      reject(err);
                                    });
                                } else {
                                  database
                                    .ref("Conversations")
                                    .child(chatuser_id)
                                    .push({
                                      uid: uid.toString(),
                                      body: messageDetails,
                                      date: presentDate,
                                      time: currentTime,
                                      name: loginUsername,
                                      text: true,
                                    })
                                    .then(() => {
                                      resolve(true);
                                    });
                                }
                              })
                              .catch((err) => {
                                reject(err);
                              });
                          });
                      }
                    })
                    .catch((err) => {
                      reject(err);
                    });
                });
            })
            .catch((err) => {
              reject(err);
            });
        });
    });
    return promise;
  }

  Uploadfiles(e) {
    if (e.target.files[0]) {
      var splittype = e.target.files[0].type.split("/");
      var filePath = e.target.files[0].name.split(".");
      //-------------- Image application condition ---------------//
      var TypeofVal = "";
      var imageVal = false;
      var docVal = false;
      var docxVal = false;
      var pdfVal = false;
      var xlsxVal = false;
      var mp3Val = false;
      var mp4Val = false;
      if (splittype[0] == "image") {
        imageVal = true;
        TypeofVal = "image";
      }
      if (filePath[1] === "rtf" || filePath[1] === "docx") {
        var finalfilePath = filePath[0] + ".doc";
      } else {
        var finalfilePath = e.target.files[0].name;
      }
      if (splittype[1] == "msword") {
        docVal = true;
        docxVal = true;
        TypeofVal = "doc";
      }
      if (splittype[1] == "pdf") {
        pdfVal = true;
        TypeofVal = "pdf";
      }
      if (
        splittype[1] == "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        xlsxVal = true;
        TypeofVal = "xlsx";
      }
      if (filePath[1] == "mp3") {
        mp3Val = true;
        TypeofVal = "mp3";
      }
      if (filePath[1] == "mp4") {
        mp4Val = true;
        TypeofVal = "mp4";
      }
      const uploadTask = firebase
        .storage()
        .ref()
        .child("image/" + finalfilePath)
        .put(e.target.files[0]);
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          //Error function
          console.log(error);
        },
        () => {
          firebase
            .storage()
            .ref("image/")
            .child(finalfilePath)
            .getDownloadURL()
            .then(async (url) => {
              var currentTime = moment().format("HH:mm");
              var presentDate = moment().format("YYYY-MM-DD");
              var imagePath = url;
              const userobj = ls.get("DocuserObj");
              var chatuser_id = localStorage.getItem("PatientSenderUID");
              var promise = new Promise((resolve, reject) => {
                database
                  .ref("Chat")
                  .child(userobj.doctor_id)
                  .child(chatuser_id)
                  .push({
                    body: imagePath,
                    uid: userobj.doctor_id.toString(),
                    filename: filePath[0],
                    image: imageVal,
                    pdf: pdfVal,
                    doc: docVal,
                    docx: docxVal,
                    xlsx: xlsxVal,
                    mp4: mp4Val,
                    mp3: mp3Val,
                    type: TypeofVal,
                    fileFormate: splittype[1],
                    date: presentDate,
                    time: currentTime,
                  })
                  .then((snap) => {
                    var key = snap.key;
                    database
                      .ref("Chat")
                      .child(chatuser_id)
                      .child(userobj.doctor_id)
                      .child(key)
                      .set({
                        body: imagePath,
                        uid: userobj.doctor_id.toString(),
                        filename: filePath[0],
                        image: imageVal,
                        pdf: pdfVal,
                        doc: docVal,
                        docx: docxVal,
                        xlsx: xlsxVal,
                        mp4: mp4Val,
                        mp3: mp3Val,
                        type: TypeofVal,
                        fileFormate: splittype[1],
                        key: key,
                        date: presentDate,
                        time: currentTime,
                      })
                      .then(() => {
                        database
                          .ref("Chat")
                          .child(userobj.doctor_id)
                          .child(chatuser_id)
                          .child(key)
                          .update({
                            key: key,
                          })
                          .then(() => {
                            //start conversations
                            database
                              .ref("Conversations")
                              .child(userobj.doctor_id)
                              .orderByChild("uid")
                              .equalTo(chatuser_id)
                              .once("value", (snapshot) => {
                                var res = snapshot.val();
                                if (res != null) {
                                  let store = Object.keys(res);
                                  database
                                    .ref("Conversations")
                                    .child(userobj.doctor_id)
                                    .child(store[0])
                                    .remove()
                                    .then(() => {
                                      database
                                        .ref("Conversations")
                                        .child(userobj.doctor_id)
                                        .push({
                                          uid: chatuser_id.toString(),
                                          body: imagePath,
                                          filename: filePath[0],
                                          image: imageVal,
                                          pdf: pdfVal,
                                          doc: docVal,
                                          docx: docxVal,
                                          xlsx: xlsxVal,
                                          mp4: mp4Val,
                                          mp3: mp3Val,
                                          type: TypeofVal,
                                          fileFormate: splittype[1],
                                          date: presentDate,
                                          time: currentTime,
                                        })
                                        .then(() => {
                                          database
                                            .ref("Conversations")
                                            .child(chatuser_id)
                                            .orderByChild("uid")
                                            .equalTo(userobj.doctor_id)
                                            .once("value", (snapshot) => {
                                              var res = snapshot.val();
                                              if (res != null) {
                                                let store = Object.keys(res);
                                                database
                                                  .ref("Conversations")
                                                  .child(chatuser_id)
                                                  .child(store[0])
                                                  .remove()
                                                  .then(() => {
                                                    database
                                                      .ref("Conversations")
                                                      .child(chatuser_id)
                                                      .push({
                                                        uid: userobj.doctor_id.toString(),
                                                        body: imagePath,
                                                        filename: filePath[0],
                                                        image: imageVal,
                                                        pdf: pdfVal,
                                                        doc: docVal,
                                                        docx: docxVal,
                                                        xlsx: xlsxVal,
                                                        mp4: mp4Val,
                                                        mp3: mp3Val,
                                                        type: TypeofVal,
                                                        fileFormate: splittype[1],
                                                        date: presentDate,
                                                        time: currentTime,
                                                      })
                                                      .then(() => {
                                                        resolve(true);
                                                      });
                                                  })
                                                  .catch((err) => {});
                                              } else {
                                                database
                                                  .ref("Conversations")
                                                  .child(chatuser_id)
                                                  .push({
                                                    uid: userobj.doctor_id.toString(),
                                                    body: imagePath,
                                                    filename: filePath[0],
                                                    image: imageVal,
                                                    pdf: pdfVal,
                                                    doc: docVal,
                                                    docx: docxVal,
                                                    xlsx: xlsxVal,
                                                    mp4: mp4Val,
                                                    mp3: mp3Val,
                                                    type: TypeofVal,
                                                    fileFormate: splittype[1],
                                                    date: presentDate,
                                                    time: currentTime,
                                                  })
                                                  .then(() => {
                                                    resolve(true);
                                                  });
                                              }
                                            })
                                            .catch((err) => {
                                              reject(err);
                                            });
                                        });
                                    })
                                    .catch((err) => {
                                      reject(err);
                                    });
                                } else {
                                  database
                                    .ref("Conversations")
                                    .child(userobj.doctor_id)
                                    .push({
                                      uid: chatuser_id.toString(),
                                      body: imagePath,
                                      filename: filePath[0],
                                      image: imageVal,
                                      pdf: pdfVal,
                                      doc: docVal,
                                      docx: docxVal,
                                      xlsx: xlsxVal,
                                      mp4: mp4Val,
                                      mp3: mp3Val,
                                      type: TypeofVal,
                                      fileFormate: splittype[1],
                                      date: presentDate,
                                      time: currentTime,
                                    })
                                    .then(() => {
                                      database
                                        .ref("Conversations")
                                        .child(chatuser_id)
                                        .orderByChild("uid")
                                        .equalTo(chatuser_id)
                                        .once("value", (snapshot) => {
                                          var res = snapshot.val();
                                          if (res != null) {
                                            let store = Object.keys(res);
                                            database
                                              .ref("Conversations")
                                              .child(chatuser_id)
                                              .child(store[0])
                                              .remove()
                                              .then(() => {
                                                database
                                                  .ref("Conversations")
                                                  .child(chatuser_id)
                                                  .push({
                                                    uid: userobj.doctor_id.toString(),
                                                    body: imagePath,
                                                    filename: filePath[0],
                                                    image: imageVal,
                                                    pdf: pdfVal,
                                                    doc: docVal,
                                                    docx: docxVal,
                                                    xlsx: xlsxVal,
                                                    mp4: mp4Val,
                                                    mp3: mp3Val,
                                                    type: TypeofVal,
                                                    fileFormate: splittype[1],
                                                    date: presentDate,
                                                    time: currentTime,
                                                  })
                                                  .then(() => {
                                                    resolve(true);
                                                  });
                                              })
                                              .catch((err) => {
                                                reject(err);
                                              });
                                          } else {
                                            database
                                              .ref("Conversations")
                                              .child(chatuser_id)
                                              .push({
                                                uid: userobj.doctor_id.toString(),
                                                body: imagePath,
                                                filename: filePath[0],
                                                image: imageVal,
                                                pdf: pdfVal,
                                                doc: docVal,
                                                docx: docxVal,
                                                xlsx: xlsxVal,
                                                mp4: mp4Val,
                                                mp3: mp3Val,
                                                type: TypeofVal,
                                                fileFormate: splittype[1],
                                                date: presentDate,
                                                time: currentTime,
                                              })
                                              .then(() => {
                                                resolve(true);
                                              });
                                          }
                                        })
                                        .catch((err) => {
                                          reject(err);
                                        });
                                    });
                                }
                              })
                              .catch((err) => {
                                reject(err);
                              });
                          });
                      })
                      .catch((err) => {
                        reject(err);
                      });
                  });
              });
              return promise;
            });
        }
      );
    }
  }
  // redirect to appointments Page
  redirect=()=>{
    window.location.href=Constant.imgurl+"/doctor/Doctordashboard";
  }
  render() {
    return (
      <section id="main_dashboard">
        <DoctorHeader onSelectLanguage={this.handleLanguage} />
        {/* Right side togle popup is open code */}

        <div class="modal" id="myModal">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <img src={this.state.OpenrightImg} class="displaydocpop" />
              </div>
            </div>
          </div>
        </div>

        {/* Left  side togle popup is open code */ }
        <div class="modal" id="myModal2">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <img src={this.state.OpenleftImg} class="displaydocpop" />
              </div>
            </div>
          </div>
        </div>
        {/* End togle popup is open code */}
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <div class="row m-0">
                    <div class="col-lg-6">
                      <ol className="breadcrumb">
                        <li className="active">
                          {/* <Link to="/doctor/Doctordashboard"> Dashboard</Link>
                          &gt; Chat Setup  */}
                            <div class="back_section" onClick={this.redirect}>
                            <h5><img src="../images/patient//img/Doctors_List/View Profile/Back.svg"/> Back</h5>
                            </div>
                        </li>
                      </ol>
                    </div>
                    <div class="col-lg-6">
                      <div class="Userprofileimg-div">
                        <span class="bold"> Dr.{this.state.doctorName} </span>
                        {this.state.doctorProfileImage ? (
                          <img
                            alt="Avatar"
                            class="Userprofileimg"
                            src={
                              Constant.imgurl + this.state.doctorProfileImage
                            }
                          ></img>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header"></div>
                      <div id="messaging">
                        <div className="doc_info">
                          <div className="doc_details">
                            {this.state.patientProfileImage ? (
                              <img
                                alt="Avatar"
                                class="Userpro_img"
                                src={this.state.patientProfileImage}
                              ></img>
                            ) : (
                              ""
                            )}
                            <h2>{this.state.PatientName}</h2>
                              
                            {this.state.messages.map((message) => {
                              const _class =
                                message.user === this.state.username
                                  ? "message-left container"
                                  : "message-right container";
                              return (
                                <div className={_class}>
                                  <h6 className="name-heading">
                                    {message.user}
                                  </h6>
                                  <p className="marg-left-10">{message.text}</p>
                                  <span className="time-left"></span>
                                </div>
                              );
                            })}
                          </div>
                          <div class="right end_sec" onClick={this.chatEndConsultation}>
                            <h3>End Chat</h3>
                            </div> 
                        </div>

                        <div id="chat_form">
                          {this.state.detialsdata}

                          <div className="row">
                            <div className="col-md-12">
                              <div
                                className="update_btn"
                                style={{ textAlign: "right" }}
                              ></div>
                            </div>
                          </div>
                          <ToastContainer />
                          <form onSubmit={this.checkSubmit.bind(this)}>
                            <div className="type_msg">
                              <div class="row">
                                <div className="col-md-12 input_msg_write">
                                  <div className="form-group input_box">
                                    {/* <label>Upload Image :</label> */}
                                    <div class="attach_box">
                                      <img src="../img/attach-file-icon.svg"></img>
                                    </div>
                                    {/* distance-icon */}
                                    <input
                                      className="form-control"
                                      type="file"
                                      id="image"
                                      onChange={this.Uploadfiles}
                                    />
                                    <input
                                      className="form-control text_box"
                                      type="text"
                                      id="sendmsg"
                                      ref={(node) => (this.input = node)}
                                    />
                                    <div class="send_box">
                                      <img
                                        src="../img/send-button-icon.svg"
                                        onClick={this.onAddMessage}
                                      ></img>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div></div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
